/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Einvoice_Stuck_Misa_Draft_OnInputs */

const vi_einvoice_stuck_misa_draft_on = /** @type {(inputs: Einvoice_Stuck_Misa_Draft_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`MISA đang giữ một nháp chưa phát hành (tạo ${i?.date}).`)
};

/**

* @param {Einvoice_Stuck_Misa_Draft_OnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_misa_draft_on = /** @type {((inputs: Einvoice_Stuck_Misa_Draft_OnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_Misa_Draft_OnInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_misa_draft_on(inputs)
});